import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  Injector
} from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'abp-modal-footer',
  templateUrl: './abp-modal-footer.component.html',
  styleUrls: ['./abp-modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbpModalFooterComponent extends AppComponentBase {
  @Input() cancelLabel = this.l('Cancel');
  @Input() cancelDisabled: boolean;
  @Input() saveLabel = this.l('Save');
  @Input() saveDisabled: boolean;
  @Input() showCancel: boolean =true;
  @Input() showCustomButton: boolean = false;
  @Input() customButtonLabel = '';
  @Input() customButtonDisabled: boolean;

  @Output() onCancelClick = new EventEmitter<number>();
  @Output() onCustomButtonClick = new EventEmitter<number>();

  constructor(injector: Injector) {
    super(injector);
  }
}
